import { getCookieHelpers, isIOSDevice } from '@/utils';
import { isForeignEnvironment } from './client';

export const isBrowser = () => typeof window !== 'undefined';

export const getCookie = (name: string) => {
	const cookieStore = getCookieHelpers();
	return cookieStore.getCookie(name);
};

export function getUrlParameter(key: string): string | undefined {
	if (!isBrowser()) return undefined;
	const searchParams = decodeURIComponent(window.location.search) || '';

	if (searchParams) {
		const indexOfKey = searchParams.indexOf(`?${key}=`);
		if (indexOfKey !== -1) {
			// +2 for the equal to sign and &
			const str = searchParams.substring(indexOfKey + key.length + 2);
			const indexOfSeperator = str.indexOf('&');
			if (indexOfSeperator === -1) {
				return str;
			} else {
				return str.substring(0, indexOfSeperator);
			}
		} else {
			const indexOfKey = searchParams.indexOf(`&${key}=`);
			if (indexOfKey !== -1) {
				// +2 for the equal to sign and &
				const str = searchParams.substring(indexOfKey + key.length + 2);
				const indexOfSeperator = str.indexOf('&');
				if (indexOfSeperator === -1) {
					return str;
				} else {
					return str.substring(0, indexOfSeperator);
				}
			}
		}
	}

	return undefined;
}

export const windowOpen = (link: string) => {
	const a = document.createElement('a');
	a.href = link;
	a.target = '_blank';
	a.rel = 'noopener noreferrer';
	a.click();
};

export const openBrowser = (url: string) => {
	if (isForeignEnvironment()) {
		if (isIOSDevice()) {
			if (url.indexOf('http') !== 0 && url.indexOf('ixigo://') !== 0) {
				// checking if its is a relative url
				url = `${window.location.hostname}${url}`;
			}
			if (window.webkit?.messageHandlers?.callbackHandler) {
				window.webkit.messageHandlers.callbackHandler.postMessage({
					openSafari: url,
				});
				return true;
			}
		} else if (
			window.IxiWebView &&
			// biome-ignore lint/suspicious/noExplicitAny: <webview handler function>
			typeof (window.IxiWebView as any).openBrowser === 'function'
		) {
			// biome-ignore lint/suspicious/noExplicitAny: <webview handler function>
			(window.IxiWebView as any).openBrowser(url);
			return true;
		}
	}
	return false;
};

/**
 * hides the overlay loader displayed by native webview
 * call it when web page is ready with themes and initial view
 */
export function onReady(): void {
	if (window.IxiWebView?.pwaReady) {
		window.IxiWebView.pwaReady();
	} else if (window.webkit?.messageHandlers?.appInterface) {
		window.webkit.messageHandlers.appInterface.postMessage('pwaReady');
	}
}

export function quit(): boolean {
	if (window.IxiWebView?.quit) {
		window.IxiWebView.quit();
		return true;
	}
	if (window.webkit?.messageHandlers?.appInterface) {
		window.webkit.messageHandlers.appInterface.postMessage('quit');
		return true;
	}
	return false;
}
